import {useNotification} from '@hconnect/uikit/src/common/'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../api/mutations'
import {notifyIfErrorMessage} from '../../../common'
import {ErrorResponse} from '../../../interfaces/api/common'

export const useSendBackupPlan = () => {
  const {notify} = useNotification()
  const {t} = useTranslation()
  const raiseError = useErrorHandler()
  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.sendBackupPlan>[0]
  >({
    mutationFn: mutations.sendBackupPlan,
    onError: (error) => {
      notify('error', t('error.backupPlanSent'))
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.backupPlanSent'))
    }
  })
}
